import { BaseDto } from "@models/base/baseDto.model"

export class ConceptoSimpleComprobanteDto extends BaseDto {
  public cuenta!: string
  public periodo!: string
  public debe: number = 0
  public haber: number = 0
}
